import type { VueI18n } from 'vue-i18n';

export const ShareI18nService = Symbol('ShareI18nService');

export type ShareI18nService = VueI18n;
